import { useSharedCheckoutContextRegion } from './use_shared_checkout_context_region';

// Seattle is not eligible for a free pickup / return.
export const useFreePickupReturnEligible = (): boolean => {
  const name = useSharedCheckoutContextRegion();
  const seattle = name === 'Seattle';

  return !seattle;
};
